<template>
    <v-container fluid class="header" v-click-outside="hideMenus">
        <h2><i @click="goBack" class="mdi mdi-arrow-left" v-if="showBack"></i><i @click="goHome" class="mdi mdi-home" v-if="showBack"></i><slot></slot></h2>
        <div class="icons">
            <span class="notifIcon" @click="isShowingNotifs" v-if="this.$store.state.routeTo.name != 'Operations'">
                <i class="mdi mdi-bell-outline"></i>
                <div v-if="this.$store.state.unSeenNotifs > 0" class="newNotif">{{this.$store.state.unSeenNotifs}}</div>
            </span>
            
            <i class="mdi mdi-dots-horizontal" @click="isShowingMenu"></i>
        </div>
        <v-expand-transition>
            <div class="menu" v-show="showMenu">
                <ul>
                    <li @click="goTo('Account')">{{ $t('messages.menu.account') }}</li>
                    <li @click="refreshData()">Mettre à jour</li>
                    <li v-if="this.$router.currentRoute.name != 'Operations'" @click="$router.push({name: 'Operations'})">Opérations</li>
                    <li @click="disconnect">{{ $t('messages.menu.disconnect') }}</li>
                    <li><LangSelector/></li>
                </ul>
            </div>
        </v-expand-transition>
        <v-expand-transition v-if="this.$store.state.routeTo.name != 'Operations'">
            <div class="notifications" v-show="showNotifMenu">
                <div style="overflow:auto; height:82vh">
                    <v-container v-if="this.$store.state.notifs.length > 0">
                        <v-card elevation="0" dense v-for="notif in this.$store.state.notifs" :key="notif.id" :class="!notif.lu ? 'unread' : ''">
                            <v-card-title>{{notif.message}}</v-card-title>
                            <v-card-subtitle>
                                <span>Il y a {{notif.duree}} </span>
                                <v-btn v-show="$store.getters.isLeadExists(notif.id_lead)" dense small depressed color="primary" @click='goToDetail(notif.id_notification, notif.id_lead)'>Détail lead</v-btn>
                                <v-btn v-show="!$store.getters.isLeadExists(notif.id_lead)" dense x-small fab dark depressed color="primary" @click='setAsRead(notif.id_notification)'><v-icon dark>mdi-check</v-icon></v-btn>
                            </v-card-subtitle>
                        </v-card>
                    </v-container>
                    <p v-if="this.$store.state.notifs.length == 0" class="text-center mt-4" style="color:black">Vous n'avez pas de notifications</p>
                </div>
            </div>
        </v-expand-transition>
    </v-container>
</template>
<script>
import LangSelector from '@/components/LangSelector'

export default {
    props: ['code'],
    data() {
        return {
            showMenu: false,
            showNotifMenu: false,
            interval: ""
        }
    },
    components: {
        LangSelector
    },
    methods: {
        refreshData(){
            this.$store.dispatch('setLoader', true).then((e) => {
                 this.$store.dispatch('refreshData', {id_utilisateur: this.$store.state.user.id, code_projet : this.code}).then((e) => {
                    this.$store.dispatch('setLoader', false)
                    this.showMenu = false
                 })
            })
        },
        goBack(){
            this.$store.dispatch('setLoader', true)
            if(this.$store.state.routeFrom.name != "Login" ){
                this.$router.go(-1)
            }else {
                this.$store.dispatch('getLeadProjets', {codeProjet: this.code}).then(() => {
                  this.$store.dispatch('getStatistiques', {codeProjet : this.code}).then(() => {
                          this.$router.push({ name: 'Todo', params: { code: this.code } })
                  })
              }) 
            }
        },
        setAsRead(notifId){
            this.$store.dispatch('setNotifRead', notifId).then((e) => {
                this.showNotifMenu = false;
            })
        },
        goToDetail(notifId, leadId) {
            this.$store.dispatch('setLoader', true).then((e) => {
                this.$store.dispatch('setNotifRead', notifId).then((e) => {
                    const lead = this.$store.state.leads.find(e => e.id == leadId);
                    this.$store.dispatch('getDetailLead', lead.code_lead).then((e) => {
                        this.$router.push({ name: 'Details', params: { code: this.code, id: leadId } })
                        this.showNotifMenu = false;
                        this.$store.dispatch('setLoader', false)
                    })
                })
            })
            
        },
        goHome(){
            this.$store.dispatch('setLoader', true).then((e) => {
                this.$store.dispatch('getLeadProjets', {codeProjet: this.code}).then(() => {
                    this.$store.dispatch('getStatistiques', {codeProjet : this.code}).then(() => {
                        this.$router.push({ name: 'Todo', params: { code: this.code } })
                    })
                }) 
            })
        },
        isShowingMenu(){
            this.showMenu = !this.showMenu
            this.showNotifMenu = false;
        },
        isShowingNotifs(){
            this.showNotifMenu = !this.showNotifMenu
            this.showMenu = false;
            if(this.$store.state.notifs.lentgh > 0){
                 let notifUnseen = this.$store.state.notifs.filter((e) => e.vu == false)
                this.$store.dispatch('setNotifSeen', notifUnseen)
            }
           
        },
        hideMenus(){
            this.showMenu = false;
            this.showNotifMenu = false;
        },
        goTo(routeName) {
            this.$router.push({ name: routeName })
        },
        disconnect() {
            this.$store.dispatch('getDisconnected', {})
            this.$router.push({ name: 'Login' })
        }
    },
    computed: {
        showBack(){
            if(this.$store.state.routeTo.name != "Todo" 
            && this.$store.state.routeTo.name != "Rdv" 
            && this.$store.state.routeTo.name != "Leads" 
            && this.$store.state.routeTo.name != "Medias" 
            && this.$store.state.routeTo.name != "Statistique"
            && this.$store.state.routeTo.name != "Operations"){
               return true 
            } else {
                return false
            }

        },
    },
    watch: {
    },
    created() {
        if(this.interval == ""){
            this.interval = setInterval(() => {
                this.$store.dispatch('getNewNotifs', {id_utilisateur: this.$store.state.user.id, code_projet : this.code})
            }, 60000);
        }
    },
    beforeDestroy() {
        clearInterval(this.interval);
    }
}
</script>
<style lang="scss">
    .header {
        position:fixed;
        top:0;
        z-index:100;
        height:8vh;
        display:flex;
        align-items:center;
        justify-content: space-between;
        background-color: #eb566b;
        color:white;
        h2 {
            display:inline-flex;
            align-items: center;
            font-size : 1.1em;
            font-weight:400;
            i {
                margin-right: 10px;
                font-size : 1.1em;
            }
        }
        .icons {
            display:flex;
            align-items: center;
            justify-content: center;
            i {
                margin-right:10px;
                font-size:1.4em;
                font-weight:normal;
            }
            .notifIcon {
                position:relative;
                margin-right:15px;
                i {
                    margin-right:0px;
                }
                .newNotif {
                    position:absolute;
                    background-color:white;
                    color:red;
                    font-size:0.8em;
                    font-weight: bold;
                    width:15px;
                    height:15px;
                    display:flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 50%;
                    right:-5px;
                    bottom:0;
                   //animation: blink 0.5s infinite alternate;
                }
            }
            
        }
        @keyframes blink {
            from { opacity: 0; }
            to { opacity: 1; }
        }
        .menu {
            position:absolute;
            z-index:10;
            border-left: 2px solid #eb566b;
            border-right: 2px solid #eb566b;
            border-bottom: 2px solid #eb566b;
            top:100%;
            right: 0;
            
            background-color:white;
            color: black;
            width:145px;
            ul {
                padding: 15px;
                li {
                    list-style-type: none;
                    margin-bottom:5px;
                    &:last-child {
                        margin-bottom:0;
                    }
                }
            }
        }
        .notifications {
            position:absolute;
            z-index:3;
            border-bottom: 2px solid #eb566b;
            background-color:#f3f5fa;
            top:100%;
            left: 0;
            width: 100vw;
            height: calc( 84vh + 2px );
            .v-card {
                margin-bottom:10px;
                border: 1px solid #fff;
                &.unread {
                    background-color:#fff3f5;
                    border: 1px solid #eb566b;
                }
                .v-card__title {
                    font-size:1em;
                    font-weight:600;
                    letter-spacing: -1px;
                    word-break: keep-all;
                    padding:10px;
                }
                .v-card__subtitle {
                    padding:10px;
                    padding-top:5px;
                    display:flex;
                    align-items:center;
                    justify-content: space-between;
                }
            }
        }
    }
</style>